import * as Yup from 'yup'
export const phoneNumberRegex = /^\d{10}$/;
export const timeSlotRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
export const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$/;
export const timeSlotAvailability = /^[0-9]{2}:[0-9]{2}$/;
export const zipCodeRegex = /^[A-Za-z0-9]{5,6}$/;
export const EMAIL = {
  label: "Email",
  validation: {
    required: "Email ID is required",
    valid: "Please enter a valid Email ID.",
    invalidCaps: 'Email is invalid, please type in lowercase.',
  },
};
export const HOSPITAL_NAME = {
  label: "Hospital Name",
  validation: {
    valid: "Hospital name is required.",
    required: "Hospital name is required"
  },
};
export const PATIENT_NAME = {
  label: "Patient Name",
  validation: {
    valid: "Patient Name is not valid",
    required: "Patient Name is required"
  }
}
export const ZIP_CODE = {
  label: "Zip Code",
  validation: {
    valid: "Zip Code must be a valid alphanumeric string with 5 or 6 characters",
    minLength: {
      value: 5,
      message: "Zip Code must be at least 5 digits",
    },
    maxLength: {
      value: 6,
      message: "Zip Code must not exceed 6 digits",
    },
  },
  regex: zipCodeRegex
};
export const CONTACT_NUMBER = {
  label: "Contact number",
  validation: {
    valid: "Please enter a valid 10-digit contact number.",
    required: "Contact number is required"
  },
};
export const NAME = {
  label: "Name",
  validation: {
    valid: "Name is required",
    required: "Name is required"
  },
};
export const BILLING_NAME = {
  label: "Name",
  validation: {
    valid: "Billing Name is required",
    required: "Billing Name is required"
  },
};
export const BILLING_ADDRESS = {
  label: "Address",
  validation: {
    valid: "Billing Address is required",
    required: "Billing Address is required"
  },
};
export const Role = {
  label: "Role",
  validation: {
    valid: "Role is required",
    required: "Role is required"
  },
};
export const Gender = {
  label: "Gender",
  validation: {
    valid: "Gender is required",
    required: "Gender is required"
  },
};
export const DOB = {
  label: "Date of Birth",
  validation: {
    valid: "Date format must be DD/MM/YYYY",
    required: "Date Of Birth is required"
  },
  regex: dateRegex,
};
export const TIME = {
  label: "Time",
  validation: {
    valid: "Time is required",
    required: "Time is required"
  },
};
export const PRIORITY = {
  label: "PRIORITY",
  validation: {
    valid: "Priority is required",
    required: "Priority is required"
  },
};
export const MODALITY = {
  label: "Modality",
  validation: {
    valid: "Modality is required",
    required: "Modality is required"
  },
};
export const AVAILABILITY = {
  label: "Availability",
  validation: {
    valid: "Availability is required",
    required: "Availability is required",
  },
};
export const RADIOLOGIST = {
  label: "Radiologist",
  validation: {
    valid: "Radiologist is required",
    required: "Radiologist is required"
  },
};
export const STUDYREGION = {
  label: "Study Region",
  validation: {
    valid: "Study region is required",
    required: "Study region is required"
  },
};
export const MACHINE_NAME = {
  label: "Machine Name",
  validation: {
    valid: "Machine Name is required",
    required: "Machine Name is required"
  },
};
export const LICENSE_NUMBER = {
  label: "LICENSE NUMBER",
  validation: {
    valid: "License number is required",
    required: "License number is required"
  },
};
export const YEARS_OF_EXP = {
  label: "Years of Experience",
  validation: {
    valid: "Years of Experience is required",
    required: "Years of Experience is required",
    positive: "Years of experience must be a positive number",
    integer: "Years of experience must be a whole number"
  },
};
export const FROM_TIME_AVAILABILITY = {
  label: "From Time Avalability",
  validation: {
    valid: "From Time Avalability is not valid",
    required: "From Time Availability is required",
  },
  regex: timeSlotAvailability,
};
export const TO_TIME_AVAILABILITY = {
  label: "To Time Avalability",
  validation: {
    valid: "To Time Avalability is not valid",
    required: "To Time Availability is required",
  },
  regex: timeSlotAvailability,
};
export const PATIENT_ID = {
  label: "PATIENT ID",
  validation: {
    valid: "Patient id is required",
    required: "Patient id is required"
  },
};
export const UHID = {
  label: "UHID",
  validation: {
    valid: "UHID is required",
    required: "UHID is required"
  },
};
export const APPOINTMENT_DATE = {
  label: "APPOINTMENT DATE",
  validation: {
    valid: "APPOINTMENT DATE is required",
    required: "APPOINTMENT DATE is required"
  },
};
export const APPOINTMENT_TIME = {
  label: "APPOINTMENT TIME",
  validation: {
    valid: "APPOINTMENT TIME is required",
    required: "APPOINTMENT TIME is required"
  },
};
export const PREF_PAYMENT_METHOD = {
  label: "PREF PAYMENT METHOD",
  validation: {
    valid: "Payment method is required",
    required: "Payment method is required"
  },
};

export const TYPE_OF_SAMPLE = {
  label: "Type of Sample",
  validation: {
    valid: "Type of sample is required.",
    required: "Type of sample is required."
  },
};

export const SAMPLE_LOCATION = {
  label: "Sample Location",
  validation: {
    valid: "Sample location is required.",
    required: "Sample location is required."
  },
};

export const SAMPLE_TIME = {
  label: "Sample Time",
  validation: {
    valid: "Sample time is required.",
    required: "Sample time is required."
  },
};

export const SLIDE_CREATION_TIME = {
  label: "Slide Creation Time",
  validation: {
    valid: "Slide creation time is required.",
    required: "Slide creation time is required."
  },
};

export const CASE_STUDY_PRIORITY = {
  label: "Case Study Priority",
  validation: {
    valid: "Case study priority is required.",
    required: "Case study priority is required."
  },
};

export const hospitalFormSchema = Yup.object().shape({
  hospitalName: Yup.string().required(HOSPITAL_NAME.validation.required),
  hospitalEmailId: Yup.string().email().required(EMAIL.validation.required),
  contactNumber: Yup.string().matches(phoneNumberRegex).required(CONTACT_NUMBER.validation.valid),
  superAdminName: Yup.string().required(NAME.validation.required),
  zipCode: Yup.string()
    .min(ZIP_CODE.validation.minLength.value, ZIP_CODE.validation.minLength.message)
    .max(ZIP_CODE.validation.maxLength.value, ZIP_CODE.validation.maxLength.message)
    .matches(ZIP_CODE.regex, ZIP_CODE.validation.valid),
  superAdminEmail: Yup.string().required(EMAIL.validation.required),
  superAdminContactNumber: Yup.string().matches(phoneNumberRegex).required(CONTACT_NUMBER.validation.valid),
  superAdminWhatsappNumber: Yup.string().matches(phoneNumberRegex).required(CONTACT_NUMBER.validation.valid)
})

export const userFormSchema =(role)=>{
  return Yup.object().shape({
    name: Yup.string().required(NAME.validation.required),
    employeeId: Yup.string(),
    role: Yup.string().required(Role.validation.required),
    hprid: Yup.string(),
    gender: Yup.string(),
    email: Yup.string().email().required(EMAIL.validation.required),
    contactNumber: Yup.string().matches(phoneNumberRegex).required(CONTACT_NUMBER.validation.valid),
    dob: Yup.date().required(DOB.validation.required),
    department: Yup.string(),
    zipCode: Yup.string()
    .min(ZIP_CODE.validation.minLength.value, ZIP_CODE.validation.minLength.message)
    .max(ZIP_CODE.validation.maxLength.value, ZIP_CODE.validation.maxLength.message)
    .matches(ZIP_CODE.regex, ZIP_CODE.validation.valid),
    availabilityDay: Yup.array().required(AVAILABILITY.validation.required),
    specialization: Yup.array(),
    yearsOfExperience: Yup.string(),
    whatsappNumber: Yup.string().matches(phoneNumberRegex, CONTACT_NUMBER.validation.valid),
    licenseNumber: role==='Admin'?Yup.string():Yup.string().required(LICENSE_NUMBER.validation.required)
  })
}

const baseSchema = {
  contactNumber: Yup.string()
    .matches(phoneNumberRegex, CONTACT_NUMBER.validation.valid)
    .required(CONTACT_NUMBER.validation.required),
  UHID: Yup.string(),
  patientId: Yup.string(),
  patientName: Yup.string(),
  date: Yup.date().min(
    new Date(new Date().setHours(0, 0, 0, 0)),
    'Date cannot be in the past'
  ),
  time: Yup.string().optional(),
  modality: Yup.string(),
  machineName: Yup.string(),
  zipCode: Yup.string()
    .min(ZIP_CODE.validation.minLength.value, ZIP_CODE.validation.minLength.message)
    .max(ZIP_CODE.validation.maxLength.value, ZIP_CODE.validation.maxLength.message)
    .matches(ZIP_CODE.regex, ZIP_CODE.validation.valid),
  studyRegion: Yup.string().optional(),
  consultingDoctorName: Yup.string(),
  referringDoctorName: Yup.string(),
  referringDoctorContactNumber: Yup.string().matches(phoneNumberRegex, CONTACT_NUMBER.validation.valid),
  referringDoctorSpeciality: Yup.string(),
  priority: Yup.string().required('Case Study is required'),
  addressLine1: Yup.string().required(BILLING_ADDRESS.validation.required),
  billingName: Yup.string().required(BILLING_NAME.validation.required),
  quesInfo: Yup.array().of(
    Yup.object().shape({
      _id: Yup.string().required(),
      question: Yup.string().required(),
      answer: Yup.string()
        .required("You must select an answer for each question")
        .oneOf(["true", "false"], "Answer must be 'Yes' or 'No'"),
    })
  ),
  investigationPrice: Yup.string(),
  price: Yup.string(),
  serviceInvestigation: Yup.array(),
};

export const appointmentFormSchema = (appointmentType, mode = 'create') => {
  let schema = { ...baseSchema };
  const isEditMode = mode === 'edit';
  const isOnlyInvestigation = appointmentType === 'only_investigation';

  if (appointmentType === 'investigation_with_modality') {
    schema = {
      ...schema,
      date: Yup.date()
        .required(DOB.validation.required)
        .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Date cannot be in the past'),
      time: Yup.string().required(TIME.validation.required),
      modality: Yup.string().required(MODALITY.validation.required),
      studyRegion: Yup.string().required(STUDYREGION.validation.required),
      machineName: Yup.string().required(MACHINE_NAME.validation.required),
      quesInfo: Yup.array()
        .of(
          Yup.object().shape({
            _id: Yup.string().required(),
            question: Yup.string().required(),
            answer: Yup.string().required('You must select an answer for each question'),
          })
        )
        .required('Questions are required'),
    };
  } else if (appointmentType === 'only_investigation') {
    schema = {
      ...schema,
      date: Yup.date().min(
        new Date(new Date().setHours(0, 0, 0, 0)),
        'Date cannot be in the past'
      ),
      time: Yup.string(),
      modality: Yup.string(),
      studyRegion: Yup.string(),
      quesInfo: Yup.array(),
      serviceInvestigation: Yup.array().when({
        is: () => isOnlyInvestigation,
        then: (schema) =>
          schema
            .required('Service Investigation is required')
            .min(1, 'At least one Service Investigation must be selected'),
        otherwise: (schema) => schema,
      }),
    };
  }else if (appointmentType === 'consultation') {
    schema = {
      ...schema,
      date: Yup.date()
        .required(DOB.validation.required)
        .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Date cannot be in the past'),
        time: Yup.string()
        .required(TIME.validation.required)
        .test(
          'is-future-time',
          'Appointment date and time cannot be in the past',
          function(value) {

            const { date } = this.parent;

            if (!date || !value) return true;

            // Combine date and time into a single datetime object
            const [initialHours, lastHour] = value.split('-');
            const [hours, minutes] = initialHours.split(':').map(Number);
            const appointmentDateTime = new Date(date);
            appointmentDateTime.setHours(hours, minutes, 0, 0);

            // Get current datetime
            const now = new Date()
            // Check if appointment is in the past
            return appointmentDateTime >= now;
          }
        ),
      studyRegion: Yup.string(),
      price: Yup.string(),
      contactNumber: Yup.string()
        .matches(phoneNumberRegex, CONTACT_NUMBER.validation.valid)
        .required(CONTACT_NUMBER.validation.required),
      priority: Yup.string(),
      modality: Yup.string().required(MODALITY.validation.required),
      quesInfo: Yup.array(),
      consultingDoctorName: Yup.string().required('Consulting Doctor is required'),
    };
  }
  if (isEditMode && isOnlyInvestigation) {
    schema.date = Yup.date().nullable();
    schema.time = Yup.string().nullable();
    schema.modality = Yup.string().nullable();
    schema.studyRegion = Yup.string().nullable();
  }
  return Yup.object().shape(schema);
};

export const newappointmentFormSchema = (appointmentType, mode = 'create') => {
  const isEditMode = mode === 'edit';
  const isOnlyInvestigation = appointmentType === 'only_investigation';
  const isOnlyModalityWithInvestigation = appointmentType === 'investigation_with_modality';
  const isOnlyConsultation = appointmentType === 'consultation';

  return Yup.object().shape({
    date: Yup.date().when({
      is: () => !isOnlyInvestigation,
      then: (schema) =>
        schema
          .required(DOB.validation.required)
          .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Date cannot be in the past'),
      otherwise: (schema) => schema.nullable(),
    }),
    time: Yup.string().when({
      is: () => !isOnlyInvestigation,
      then: (schema) =>
        schema
          .required(TIME.validation.required)
          .test(
            'is-future-time',
            'Appointment date and time cannot be in the past',
            function (value) {
              const { date } = this.parent;
              if (!date || !value) return true;

              const [initialHours] = value.split('-');
              const [hours, minutes] = initialHours.split(':').map(Number);
              const appointmentDateTime = new Date(date);
              appointmentDateTime.setHours(hours, minutes, 0, 0);

              const now = new Date();
              return appointmentDateTime >= now;
            }
          ),
      otherwise: (schema) => schema.nullable(),
    }),
    modality: Yup.string().when({
      is: () => isOnlyModalityWithInvestigation,
      then: (schema) => schema.required(MODALITY.validation.required),
      otherwise: (schema) => schema.nullable(),
    }),
    studyRegion: Yup.string().when({
      is: () => isOnlyModalityWithInvestigation,
      then: (schema) => schema.required(STUDYREGION.validation.required),
      otherwise: (schema) => schema.nullable(),
    }),
    machineName: Yup.string().when({
      is: () => isOnlyModalityWithInvestigation,
      then: (schema) => schema.required(MACHINE_NAME.validation.required),
      otherwise: (schema) => schema.nullable(),
    }),
    consultingDoctorName: Yup.string().when({
      is: () => isOnlyConsultation,
      then: (schema) => schema.required('Consulting Doctor is required'),
      otherwise: (schema) => schema,
    }),
    referringDoctorName: Yup.string(),
    referringDoctorContactNumber: Yup.string().matches(
      phoneNumberRegex,
      CONTACT_NUMBER.validation.valid
    ),
    referringDoctorSpeciality: Yup.string(),
    priority: Yup.string().required(PRIORITY.validation.required),
    billingName: Yup.string().required(BILLING_NAME.validation.required),
    addressLine1: Yup.string().required(BILLING_ADDRESS.validation.required),
    serviceInvestigation: Yup.array().when({
      is: () => isOnlyInvestigation,
      then: (schema) =>
        schema
          .required('Service Investigation is required')
          .min(1, 'At least one Service Investigation must be selected'),
      otherwise: (schema) => schema,
    }),
    quesInfo: Yup.array().when({
      is: () => isOnlyModalityWithInvestigation,
      then: (schema) =>
        schema
          .of(
            Yup.object().shape({
              _id: Yup.string().required(),
              question: Yup.string().required(),
              answer: Yup.string().required('You must select an answer for each question'),
            })
          )
          .required('Questions are required'),
      otherwise: (schema) => schema,
    }),
  });
};

export const sampleFormSchema = Yup.object().shape({
  typeOfSample: Yup.string().required(TYPE_OF_SAMPLE.validation.required),
  sampleLocation: Yup.string().required(SAMPLE_LOCATION.validation.required),
  sampleTime: Yup.string().nullable().required(SAMPLE_TIME.validation.required),
  slideCreationTime: Yup.string().nullable().required(SLIDE_CREATION_TIME.validation.required),
  priority:Yup.string().nullable().required(CASE_STUDY_PRIORITY.validation.required)
});
